import {IShowUnitAttack} from "../../../models/game/IShowUnitAttack";
import {IShowMiddleware} from "../../../models/game/IShowMiddleware";
import {IShowHpChange} from "../../../models/game/IShowHpChange";
import {IShowUnitADChange} from "../../../models/game/IShowUnitADChange";
import {ICoords} from "../../../models/animations/ICoords";

export interface AnimationState {
    showUnitAttack: IShowUnitAttack,
    showMiddleware: IShowMiddleware,
    showHpChange: IShowHpChange,
    showUnitADChange: IShowUnitADChange,
    showPlayUnitHover: any,
    coords: ICoords
}

export enum AnimationActionEnum {
    SET_SHOW_UNIT_ATTACK = 'SET_SHOW_UNIT_ATTACK',
    SET_SHOW_MIDDLEWARE = 'SET_SHOW_MIDDLEWARE',
    SET_SHOW_HP_CHANGE = 'SET_SHOW_HP_CHANGE',
    SET_SHOW_UNIT_AD_CHANGE = 'SET_SHOW_UNIT_AD_CHANGE',
    SET_PLAY_UNIT_HOVER = 'SET_PLAY_UNIT_HOVER',
    SET_COORDS = 'SET_COORDS'
}

export interface SetShowUnitAttackAction {
    type: AnimationActionEnum.SET_SHOW_UNIT_ATTACK;
    payload: IShowUnitAttack;
}
export interface SetShowMiddlewareAction {
    type: AnimationActionEnum.SET_SHOW_MIDDLEWARE;
    payload: IShowMiddleware;
}
export interface SetShowHpChangeAction {
    type: AnimationActionEnum.SET_SHOW_HP_CHANGE;
    payload: IShowHpChange;
}
export interface SetShowUnitADChangeAction {
    type: AnimationActionEnum.SET_SHOW_UNIT_AD_CHANGE;
    payload: IShowUnitADChange;
}
export interface SetShowPlayUnitHoverAction {
    type: AnimationActionEnum.SET_PLAY_UNIT_HOVER;
    payload: any;
}
export interface SetCoordsAction {
    type: AnimationActionEnum.SET_COORDS;
    payload: ICoords;
}

export type AnimationAction =
    SetShowUnitAttackAction |
    SetShowMiddlewareAction |
    SetShowHpChangeAction   |
    SetShowUnitADChangeAction |
    SetShowPlayUnitHoverAction |
    SetCoordsAction
